module.exports = __webpack_public_path__ + "static/img/btn-transfer-top.9ffb8284.gif";